import "./style";
import App from "./components/app";

export default App;



// WEBPACK FOOTER //
// ./index.js